<template>
    <div class="info-edit">
        <!-- 头部 -->
        <head-bar title="修改预付款密码" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <router-link to="/">
                        <i class="head-home-icon"></i>
                    </router-link>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <div class="main_content">
            <!-- 第四步 -->
            <div
                class="step_sms_container"
                v-show="currentStep == stepMap.STEP_SMS"
            >
                <div class="sms_words">
                    <p>
                        向&nbsp;{{
                            walletInfo.registerPhoneNo | encryptionPhone
                        }}&nbsp;的手机号码发送验证码
                    </p>
                </div>
                <div class="sms_form">
                    <van-field
                        v-model="applyForm.sms"
                        center
                        label="短信验证码"
                        placeholder="请输入短信验证码"
                        maxlength="4"
                    >
                        <template #button>
                            <van-button
                                @click="sendSms"
                                size="small"
                                type="primary"
                                :disabled="isSend"
                                >{{
                                    isSend ? `${seconds}s` : "发送验证码"
                                }}</van-button
                            >
                        </template>
                    </van-field>
                </div>
                <div class="button_group">
                    <div
                        class="button_item margin_top_40"
                        @click="confirmSmsCode"
                    >
                        <span>下一步</span>
                    </div>
                    <div
                        class="button_item skip_button margin_top_20"
                        @click="goToBack"
                    >
                        <span>返回</span>
                    </div>
                </div>
            </div>
            <!-- 第四步 -->
            <div
                class="step_password_container"
                v-show="currentStep == stepMap.STEP_PASSWORD"
            >
                <div class="marked_words">
                    <p>请输入6位数字密码</p>
                </div>
                <div class="password_form">
                    <van-field
                        label="*设置密码："
                        v-model="applyForm.password"
                        type="password"
                        placeholder="请输入密码"
                        maxlength="6"
                    />
                    <van-field
                        label="*确认密码："
                        v-model="applyForm.confirmPassword"
                        type="password"
                        placeholder="请输入密码"
                        maxlength="6"
                    />
                </div>
                <div class="button_group">
                    <div
                        class="button_item margin_top_40"
                        @click="confirmPasswordUpdate"
                    >
                        <span>确认</span>
                    </div>
                    <div
                        class="button_item skip_button margin_top_20"
                        @click="onPrevStep"
                    >
                        <span>返回</span>
                    </div>
                </div>
            </div>
            <!-- 第二步 -->
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { Field, Button, Switch, Cell, Dialog } from "vant";
import md5 from "md5";
import HeadBar from "@/components/HeadBar";
import { isEmpty, isWalletPassword } from "@/utils/validation";

Vue.use(Field);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(Dialog);

let timer = null;

function cancelTimer() {
    timer && window.clearInterval(timer);
}

function setTimer(duration = 0, wait, callback) {
    cancelTimer();
    let count = duration;
    let isEnd = false;
    timer = window.setInterval(() => {
        count -= 1;
        if (count <= 0) {
            isEnd = true;
            cancelTimer();
        }
        callback && callback(count, isEnd, cancelTimer);
    }, wait);
}

const seconds_duration = 60;

const STEP_SMS = "step_sms";

const STEP_PASSWORD = "step_password";

export default {
    components: { HeadBar },
    data() {
        return {
            /* 表单数据 */
            applyForm: {
                sms: "",
                password: "",
                confirmPassword: "",
            },
            /* 开票类型列表数据 */
            walletInfo: {
                companyName: "",
                registerPhoneNo: "",
            },
            isLoda: false,
            isSend: false,
            seconds: seconds_duration,
            currentStep: STEP_SMS,
            stepMap: {
                STEP_SMS,
                STEP_PASSWORD,
            },
        };
    },
    computed: {},
    created() {
        this.getWalletInfo();
    },
    methods: {
        /**
         * @description 获取用户钱包信息
         */
        getWalletInfo() {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            const url = this.$api.userApi.queryWalletInfo;
            this.$axios
                .post(url, {})
                .then((res) => {
                    let { data: walletInfo = {} } = res;
                    this.walletInfo = walletInfo;
                })
                .catch(() => {
                    this.goToBack();
                })
                .finally(() => {
                    this.$toast.clear();
                });
        },
        sendSms() {
            if (this.isSend) return;
            let _this = this;
            const url = this.$api.userApi.resetWalletPasswordSms;
            this.$axios
                .post(url)
                .then(() => {
                    _this.isSend = true;
                    _this.$toast("发送成功");
                    setTimer(seconds_duration, 1000, (count, isEnd, cancel) => {
                        _this.seconds = count;
                        if (isEnd) {
                            _this.isSend = false;
                        }
                    });
                })
                .catch(({ msg }) => {
                    if (!isEmpty(msg)) {
                        _this.$toast(msg);
                    }
                });
        },
        //确认验证码
        confirmSmsCode() {
            if (this.isLoda) return false;
            let { sms } = this.applyForm;
            let smsLen = sms.length || 0;
            let min_len = 4;
            if (!isEmpty(sms) && smsLen == min_len) {
                let _this = this;
                const url = this.$api.userApi.validateWalletPasswordSms;
                this.$axios
                    .post(url, {
                        context: {
                            verificationCode: sms,
                        },
                    })
                    .then((res) => {
                        _this.currentStep = STEP_PASSWORD;
                    })
                    .catch(({ msg }) => {
                        if (!isEmpty(msg)) {
                            _this.$toast(msg);
                        }
                    })
                    .finally(() => {
                        _this.isLoda = false;
                    });
            } else {
                this.$toast("请输入正确的验证码");
            }
        },
        confirmPasswordUpdate() {
            if (this.isLoda) return;

            let _this = this;

            let { password = "", confirmPassword = "" } = this.applyForm;

            if (!isWalletPassword(password)) {
                this.$toast("请输入6位数字密码");
                return false;
            }

            if (password != confirmPassword) {
                this.$toast("输入的密码不一致");
                return false;
            }

            let { walletId } = this.walletInfo;
            const url = this.$api.userApi.updateWalletPassword;
            _this.isLoda = true;
            _this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(url, {
                    context: {
                        walletId: walletId,
                        walletPassword: md5(password),
                    },
                })
                .then(() => {
                    _this.$toast("操作成功");
                    _this.goToBack();
                })
                .catch(({ msg }) => {
                    if (!isEmpty(msg)) {
                        _this.$toast(msg);
                    }
                })
                .finally(() => {
                    _this.isLoda = false;
                });
        },
        onPrevStep() {
            this.currentStep = STEP_SMS;
        },
        goToBack() {
            this.$router.replace({
                path: "/user/wallet",
            });
        },
    },
};
</script>

<style lang="less" scoped>
.info-edit {
    .head-right-slot {
        height: 100%;
        text-align: right;
        padding-right: 20px;

        i {
            *display: inline;
            display: inline-block;
            zoom: 1;
            width: 60px;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: center;
            margin: 0 10px;

            &.head-search-icon {
                background-image: url(../../../public/images/head/head-search-icon.png);
            }

            &.head-home-icon {
                background-image: url(../../../public/images/head/head-home-icon.png);
            }
        }
    }

    .main_content {
        padding-top: 90px;
        .marked_words {
            height: 70px;
            background-color: #faf8d9;
            font-size: 28px;
            line-height: 70px;
            font-weight: 400;
            color: #ff5500;
            text-align: center;
        }

        .sms_words {
            height: 70px;
            background-color: #fff;
            font-size: 28px;
            line-height: 70px;
            font-weight: 400;
            color: #333;
            text-align: center;
        }

        .caption_text {
            padding: 0 30px;
            height: 100px;
            background-color: #fff;
            font-size: 32px;
            line-height: 100px;
            color: #333;
        }
        .button_group {
            width: 750px;
            .button_item {
                margin: 0 auto;
                width: 690px;
                height: 70px;
                background-color: #4bc227;
                border-radius: 36px;
                font-size: 28px;
                line-height: 70px;
                color: #fff;
                text-align: center;
                &.margin_top_40 {
                    margin-top: 40px;
                }

                &.margin_top_20 {
                    margin-top: 20px;
                }

                &.skip_button {
                    background-color: #96eb7c;
                }
            }
        }

        .step_recharge_container {
            width: 750px;
            .payment_info,
            .money_info {
                margin: 20px 0 0 0;
            }
        }
    }
}
</style>
